import { Classes, Dialog, Popover, Spinner } from "@blueprintjs/core"
import { observer } from "mobx-react"
import React from "react"
import { FileLink } from "modules/common/components/files/FileLink"
import { Buttons } from "modules/common/components/form"
import { PlanrButton } from "modules/common/components/planr/button/Button"
import { PlanRDndUploader } from "modules/common/components/planr/dndUploader/FileDndUploader"
import { GeneralIcon } from "modules/common/components/planr/icon/Generalcon"
import styles from "./OwnSignaturesFilesList.module.scss"
import { EmployeeSignatureFileType, EmployeeSignatureInfoType, EmployeeSignaturesListType } from './models/employee-signatures'
import { signatureTypeList } from 'modules/orders-manage/details/content-task/CategoryBlock'
import { DefaultSelectedOption, filterItemPredicate, renderSingleOption, SimpleSelect } from 'modules/common/services/form/select'
import { getEcpColor } from 'modules/orders-manage/details/content-task/ContentTask'
import moment from 'moment'

// import { SignatureAssignDialog } from "./SignatureAssignDialog"

interface TTaskFile {
  id: string
  name: string
}

type TWorkType = 'worked' | 'checked' | 'control' | 'legal' | 'gip'

interface TResultWorker {
  id: string
  name: string
  type: TWorkType
  signed: boolean
}

interface SignaturesListBaseProps {
  isOpen: boolean
  onClose: () => void
  baseUrl: string
  store: EmployeeSignaturesListType
  userId: string
  onVerifySignature: (fileId: EmployeeSignatureFileType) => void
  onSignFile: (file: EmployeeSignatureFileType) => void
  onSignRoleFile: (file: EmployeeSignatureFileType, employerRole: EmployeeSignatureInfoType) => void

}

interface SignaturesManagerDialogState {
  uploading: boolean
  showUploadDialog: boolean
  taskFiles: TTaskFile[]
  selectedFileForAssign: EmployeeSignatureFileType | null
  showAssignDialog: boolean
  loading: boolean
  versionDownloading: Record<string, boolean>
  showDelete: boolean
  showResetWarning: boolean
  selectedDeleteVersion: EmployeeSignatureFileType | null
  implementer: SelectItem
  selectedType: { id: string; label: string }
  selectedLegal: SelectItem
  legal: boolean
  employersWorked: TResultWorker[]
  employersLegal: TResultWorker[]
  implementerSelectKey: number

  showNoEcpWarning: boolean
  noEcpEmployees: Array<{ name: string, type: string, personType: string }>
  expiredEcpEmployees: Array<{ name: string, type: string, personType: string, expiryDate: string }>

}

class SignaturesListBase extends React.Component<
  SignaturesListBaseProps,
  SignaturesManagerDialogState
> {
  constructor(props: SignaturesListBaseProps) {
    super(props)
    this.state = {
      uploading: false,
      showUploadDialog: false,
      taskFiles: [],
      selectedFileForAssign: null,
      showAssignDialog: false,
      loading: false,
      versionDownloading: {},
      selectedDeleteVersion: null,
      showDelete: false,
      showResetWarning: false,
      employersWorked: [],
      employersLegal: [],
      implementer: { id: "", label: "" },
      selectedType: { id: "", label: "" },
      selectedLegal: { id: "", label: "" },
      legal: false,
      implementerSelectKey: 0,

      showNoEcpWarning: false,
      noEcpEmployees: [],
      expiredEcpEmployees: [],
    }
  }

  async componentDidMount() {
    this.setState({ loading: true })
    await this.props.store.init()
    await this.props.store.load()
    this.setState({ loading: false })
  }

  taskFilesUpload = async (file: File) => {
    const result = await this.props.store.uploadFile(file)
    if (result) {
      const newFile = { id: result?.fileId, name: result?.fileName }
      this.setState({ taskFiles: [...this.state.taskFiles, newFile] })
    }
  };

  removeTaskFilesFromState = (fileId: string) => {
    this.setState({ taskFiles: this.state.taskFiles.filter((item) => item.id !== fileId) })
  };

  saveUploadedFiles = async () => {
    if (this.state.uploading) return
    this.setState({ uploading: true })
    const result = await this.props.store.saveFiles(
      this.state.taskFiles
    )
    if (result) {
      this.closeUploadDialog()
    } else {
      this.setState({ uploading: false })
    }
  };


  handleSaveSignatures = async (
    employersWorked: Array<{ id: string; name: string; type: string; signed: boolean }>,
    employersLegal: Array<{ id: string; name: string; type: string; signed: boolean }>,
    legal: boolean
  ) => {
    if (!this.state.selectedFileForAssign) return



    // const result = await this.props.store.saveDevelopers(
    //   this.props.orderId,
    //   this.props.contentGuid,
    //   this.state.selectedFileForAssign.id,
    //   employersWorked,
    //   employersLegal,
    //   legal,
    //   this.props.orderName,
    //   this.state.selectedFileForAssign.name
    // )

    // if (result) {
    //   // Обновляем подписи в локальном состоянии
    //   const updatedSignatures = [...employersWorked, ...employersLegal].map((e) => ({
    //     employerId: e.id,
    //     employerName: e.name,
    //     signerType: e.type,
    //     signed: false,
    //   }))

    //   this.setState((prev) => ({
    //     uploadedFiles: prev.uploadedFiles.map((f) =>
    //       f.id === prev.selectedFileForAssign?.id
    //         ? { ...f, signatures: updatedSignatures }
    //         : f
    //     ),
    //     showAssignDialog: false,
    //     selectedFileForAssign: null,
    //   }))

    //   this.props.store.notify?.success("Подписанты сохранены")
    // }
  }

  openUploadDialog = () => {
    this.setState({ showUploadDialog: true, taskFiles: [] })
  }

  closeUploadDialog = () => {
    this.setState({ showUploadDialog: false, uploading: false, taskFiles: [] })
  }

  closeAssignDialog = () => {
    this.setState({ showAssignDialog: false, selectedFileForAssign: null })
  }

  openAssignDialogForFile = (file: EmployeeSignatureFileType) => {
    this.setState({
      selectedFileForAssign: file,
      showAssignDialog: true,
      employersWorked: file.employers?.filter((f) => f.signerType !== 'legal').map((s) => ({
        id: s.employerId,
        name: s.employerName,
        type: s.signerType as TWorkType,
        signed: s.signed
      })) || [],
      employersLegal: file.employers?.filter((f) => f.signerType === 'legal').map((s) => ({
        id: s.employerId,
        name: s.employerName,
        type: s.signerType as TWorkType,
        signed: s.signed
      })) || [],
      legal: (file.employers?.filter((f) => f.signerType === 'legal').length || 0) > 0
    })
  }

  toggleAsignDialog = () => {
    this.setState({
      showAssignDialog: !this.state.showAssignDialog,
      employersWorked: [],
      employersLegal: [],
      implementer: { id: "", label: "" },
      selectedType: { id: "", label: "" },
      legal: false
    })
  };

  showType = (type: TWorkType) => {
    const found = signatureTypeList.find((item) => item.id === type)
    return found?.label || type
  };

  removeDeveloper = (indexItem: number, type: string) => {
    if (type !== 'legal') {
      this.setState({ employersWorked: this.state.employersWorked.filter((item, index) => index !== indexItem) })
    }
    if (type === 'legal') {
      this.setState({ employersLegal: this.state.employersLegal.filter((item, index) => index !== indexItem) })
    }
  };

  addNewDeveloper = () => {
    const { implementer, selectedType } = this.state
    if (implementer.id === '' || selectedType.id === '') return

    let cleanName = implementer.label
    if (cleanName.startsWith('(сотр) ')) {
      cleanName = cleanName.substring(7)
    }
    if (cleanName.startsWith('(аутс) ')) {
      cleanName = cleanName.substring(7)
    }

    let newItem = {
      id: this.state.implementer.id,
      name: cleanName,
      type: (selectedType.id as any),
      signed: false
    }

    this.setState({
      employersWorked: [...this.state.employersWorked, newItem],
      implementer: { id: "", label: "" },
      selectedType: { id: "", label: "" },
      implementerSelectKey: this.state.implementerSelectKey + 1
    })
  };

  addNewLegal = () => {
    const { selectedLegal, selectedType } = this.state
    if (selectedLegal.id === '') return

    let cleanName = selectedLegal.label
    if (cleanName.startsWith('(сотр) ')) {
      cleanName = cleanName.substring(7)
    }
    if (cleanName.startsWith('(аутс) ')) {
      cleanName = cleanName.substring(7)
    }

    let newItem = {
      id: this.state.selectedLegal.id,
      name: cleanName,
      type: (selectedType.id as any),
      signed: false
    }

    this.setState({
      employersLegal: [...this.state.employersLegal, newItem],
      selectedLegal: { id: "", label: "" },
      selectedType: { id: "", label: "" },
      // implementerSelectKey: this.state.implementerSelectKey + 1
    })
  };


  saveDevelopers = async () => {
    const resultFile = this.props.store.files.find(
      (f) => f.id === this.state.selectedFileForAssign?.id
    )
    if (!resultFile) return

    const existingSigners = resultFile.employers || []
    const currentSignerIds = new Set([
      ...this.state.employersWorked.map((e) => e.id),
      ...this.state.employersLegal.map((e) => e.id)
    ])

    const removedSigners = existingSigners.filter(
      (signer) => !currentSignerIds.has(signer.employerId)
    )

    const hadSignatures = removedSigners.some((signer) => signer.signed)

    if (hadSignatures) {
      this.setState({ showResetWarning: true })
      return
    }

    // Проверка на наличие и срок действия ЭЦП у выбранных сотрудников и аутсорсеров
    const employeesWithoutEcp = []
    const employeesWithExpiredEcp = []
    const currentDate = moment().startOf('day')

    // Проверяем всех выбранных сотрудников (работающих)
    for (const emp of this.state.employersWorked) {
      // Проверяем в списке сотрудников
      const employeeData = this.props.store.employee.employee.find((e) => e.id === emp.id)
      // Проверяем в списке аутсорсеров
      const outsourcerData = this.props.store.outsourcers.outsourcers.find((a) => a.id === emp.id)

      // Определяем тип и данные
      const personData = employeeData || outsourcerData
      const personType = employeeData ? 'сотрудник' : (outsourcerData ? 'аутсорсер' : 'неизвестно')

      if (!personData?.signDateTo) {
        employeesWithoutEcp.push({
          name: emp.name,
          type: this.showType(emp.type),
          personType: personType
        })
      } else {
        // Проверяем, не истек ли срок действия ЭЦП
        const expiryDate = moment(personData.signDateTo, 'DD.MM.YYYY')
        if (expiryDate.isBefore(currentDate)) {
          employeesWithExpiredEcp.push({
            name: emp.name,
            type: this.showType(emp.type),
            personType: personType,
            expiryDate: personData.signDateTo
          })
        }
      }
    }

    // Проверяем юридические лица
    for (const emp of this.state.employersLegal) {
      // Ищем сначала в сотрудниках, потом в аутсорсерах
      const employeeData = this.props.store.employee.employee.find((e) => e.id === emp.id)
      const outsourcerData = this.props.store.outsourcers.outsourcers.find((a) => a.id === emp.id)

      // Определяем тип и данные
      let personData = employeeData || outsourcerData
      let personType = employeeData ? 'сотрудник' : (outsourcerData ? 'аутсорсер' : 'неизвестно')

      // Если нашли данные (и сотрудник, и аутсорсер могут иметь signDateTo)
      if (!personData?.signDateTo) {
        employeesWithoutEcp.push({
          name: emp.name,
          type: this.showType(emp.type),
          personType: personType
        })
      } else {
        // Проверяем, не истек ли срок действия ЭЦП
        const expiryDate = moment(personData.signDateTo, 'DD.MM.YYYY')
        if (expiryDate.isBefore(currentDate)) {
          employeesWithExpiredEcp.push({
            name: emp.name,
            type: this.showType(emp.type),
            personType: personType,
            expiryDate: personData.signDateTo
          })
        }
      }
    }

    if (employeesWithoutEcp.length > 0 || employeesWithExpiredEcp.length > 0) {
      this.setState({
        noEcpEmployees: employeesWithoutEcp,
        expiredEcpEmployees: employeesWithExpiredEcp,
        showNoEcpWarning: true
      })
      return
    }

    await this.performSaveDevelopers()
  }


  confirmSaveDevelopers = async () => {
    this.setState({ showResetWarning: false })
    await this.performSaveDevelopers()
  };

  performSaveDevelopers = async () => {

    if (this.state.selectedFileForAssign) {
      const result = await this.props.store.saveDevelopers(
        this.state.selectedFileForAssign?.fileId,
        this.state.selectedFileForAssign?.fileName,
        this.state.selectedFileForAssign?.version,
        this.state.employersWorked,
        this.state.employersLegal,
        this.state.legal,
      )

      if (result) {
        this.toggleAsignDialog()
      }
    }

  };



  renderFileRow = (file: EmployeeSignatureFileType, allVersions?: EmployeeSignatureFileType[]) => {
    const signatures = file.employers || []
    const noRoles = file.noRoles || []
    const allSigned = (signatures.length > 0 && signatures.every((s) => s.signed)) || (noRoles.length > 0 && signatures.length === 0)
    const userSignatures = file.employers?.filter((s: any) => s.employerId === this.props.userId) || []
    // Проверяем, есть ли неподписанные роли у пользователя
    const hasUnsignedRoles = userSignatures.some((s: any) => !s.signed)
    // Если allVersions не передан, получаем все версии этого файла из store
    const versions = allVersions || this.props.store.files
      .filter((f) => f.fileName === file.fileName)
      .sort((a, b) => b.version - a.version)

    return (
      <div
        key={file.id}
        className={styles.fileVersionGroup}
        style={allSigned ? { borderColor: "#1dd278" } : {}}
      >
        <div className={styles.fileRow}>

          <div className={styles.fileNameCol}>
            <FileLink
              baseUrl={this.props.baseUrl}
              file={{
                fileId: file.id,
                fileName: file.fileName,
              }}
              readOnly={true}
              onRemove={() => { }}
              style={{
                whiteSpace: "normal",
                fontSize: " 10px",
                height: "auto",
                padding: "8px 12px",
                borderColor: "#ea561e",
                color: "#ea561e"
              }}
            />
          </div>
          <div className={styles.fileVersionCol}>
            <Popover
              position="right"
              usePortal={true}
              interactionKind="hover"
              content={
                <VersionDetails
                  fileVersions={versions}
                  baseUrl={this.props.baseUrl}
                  downloadVersion={this.props.store.downloadVersion}
                  removeVersion={this.props.store.removeVersion}
                />
              }
              modifiers={{
                preventOverflow: { enabled: true, boundariesElement: 'viewport' },
                flip: { enabled: true, boundariesElement: 'viewport' }
              }}
            >
              <span className={styles.versionLink}>
                Версия_{file.version}
                {versions.length > 1 && (
                  <GeneralIcon
                    type="general-arrow-down"
                    style={{ marginLeft: '4px', fontSize: '10px' }}
                  />
                )}
              </span>
            </Popover>
          </div>
          <div className={styles.fileDateCol}>
            {file.date}
            <br />
            <span className={styles.time}>{file.time || ""}</span>
          </div>
          <div className={styles.fileActionsCol}>
            <div className={styles.buttons}>
              <PlanrButton
                type="lightblueish"
                size="small"
                title="Настроить подписи"
                icon="general-add-user"
                onClick={() => this.openAssignDialogForFile(file)}
              />
              <DownloadButton
                title='Скачать файл с ЭЦП'
                loading={this.state.versionDownloading[file.id] || false}
                onClick={async () => {
                  try {
                    this.setState((prev) => ({
                      versionDownloading: {
                        ...prev.versionDownloading,
                        [file.id]: true
                      }
                    }))
                    await this.props.store.downloadVersion(file.fileId, file.version)
                  } finally {
                    this.setState((prev) => ({
                      versionDownloading: {
                        ...prev.versionDownloading,
                        [file.id]: false
                      }
                    }))
                  }
                }}
              />
              <PlanrButton
                type="lightdanger"
                size="small"
                icon="general-trash"
                title="Удалить версию"
                onClick={() => this.setState({ showDelete: true, selectedDeleteVersion: file })}
              />
            </div>
            <div className={styles.buttons}>
              <PlanrButton
                type='blueish'
                size="small"
                style={{ width: '190px', marginLeft: "0px", marginTop: "8px" }}
                onClick={() => this.props.onSignFile(file)}
              >
                Подписать без роли
              </PlanrButton>
            </div>

            {!allSigned && hasUnsignedRoles && (
              <PlanrButton
                type='greenish'
                size="small"
                style={{ width: '190px', marginLeft: "0px", marginTop: "8px" }}
                onClick={() => {
                  // Находим первую неподписанную роль пользователя
                  const firstUnsigned = userSignatures.find((s: any) => !s.signed)

                  if (firstUnsigned) {
                    this.props.onSignRoleFile(file, firstUnsigned)
                  }
                }}
              >
                Подписать свою роль
              </PlanrButton>
            )}

            {/* Если все подписали - показываем статус */}
            {allSigned && (
              <span className={styles.allSignedLabel}>
                <GeneralIcon type="general-check" style={{ marginRight: '4px', color: '#1DD278' }} />
                Подписано
              </span>
            )}
            {(signatures.some((s) => s.signed) || noRoles.some((s) => s.signed)) && (
              <div className={styles.buttons}> <PlanrButton
                type='secondary'
                size="small"
                style={{ width: '190px', marginLeft: "0px", marginTop: "8px" }}
                onClick={() => { this.props.onVerifySignature(file) }}
              >
                Проверить ЭЦП
              </PlanrButton></div>
            )}
          </div>
        </div>


        {/* Отображение подписей */}
        {
          noRoles.length > 0 && (
            <div className={styles.signaturesNoRoles}>Подписей без роли: {noRoles.length}</div>)}
        {
          signatures.length > 0 && (
            <div className={styles.signaturesContainer}>
              <div className={styles.signaturesThreeColumns}>
                {/* Столбец "Разработал" */}
                <div className={styles.signatureColumn}>
                  <div className={styles.columnHeader}>Разработал</div>
                  {signatures
                    .filter((s) => s.signerType === "worked")
                    .map((s) => (
                      <div key={`worked-${s.employerId}`} className={styles.signatureRow}>
                        <span className={styles.signerName} title={s.employerName}>
                          {s.employerName}
                        </span>
                        <span
                          className={
                            s.signed ? styles.signedBadge : styles.notSignedBadge
                          }
                        >
                          {s.signed ? "Подпись" : "Нет"}
                        </span>
                      </div>
                    ))}
                  {signatures.filter((s) => s.signerType === "worked").length === 0 && (
                    <div className={styles.emptyColumn}>—</div>
                  )}
                </div>

                {/* Столбец "Проверил" | "рук отдела"*/}
                <div className={styles.signatureColumn}>
                  <div className={styles.columnHeader}>Проверил</div>
                  {signatures
                    .filter((s) => s.signerType === "checked")
                    .map((s) => (
                      <div key={`checked-${s.employerId}`} className={styles.signatureRow}>
                        <span className={styles.signerName} title={s.employerName}>
                          {s.employerName}
                        </span>
                        <span
                          className={
                            s.signed ? styles.signedBadge : styles.notSignedBadge
                          }
                        >
                          {s.signed ? "Подпись" : "Нет"}
                        </span>
                      </div>
                    ))}
                  {signatures.filter((s) => s.signerType === "checked").length === 0 && (
                    <div className={styles.emptyColumn}>—</div>
                  )}

                  {/* Рук отдела */}
                  {signatures.some((s) => s.signerType === "leader") && (
                    <div className={styles.legalSection}>
                      <div className={styles.legalHeader}>Начальник отдела</div>
                      {signatures
                        .filter((s) => s.signerType === "leader")
                        .map((s) => (
                          <div key={`leader-${s.employerId}`} className={styles.signatureRow}>
                            <span className={styles.signerName} title={s.employerName}>
                              {s.employerName}
                            </span>
                            <span
                              className={
                                s.signed ? styles.signedBadge : styles.notSignedBadge
                              }
                            >
                              {s.signed ? "Подпись" : "Нет"}
                            </span>
                          </div>
                        ))}
                    </div>
                  )}
                </div>

                {/* Столбец "Нормоконтроль" + Юр.лицо + ГИП */}
                <div className={styles.signatureColumn}>
                  <div className={styles.columnHeader}>Нормоконтроль</div>
                  {signatures
                    .filter((s) => s.signerType === "control")
                    .map((s) => (
                      <div key={`control-${s.employerId}`} className={styles.signatureRow}>
                        <span className={styles.signerName} title={s.employerName}>
                          {s.employerName}
                        </span>
                        <span
                          className={
                            s.signed ? styles.signedBadge : styles.notSignedBadge
                          }
                        >
                          {s.signed ? "Подпись" : "Нет"}
                        </span>
                      </div>
                    ))}
                  {signatures.filter((s) => s.signerType === "control").length === 0 && (
                    <div className={styles.emptyColumn}>—</div>
                  )}

                  {/* ГИП */}
                  {signatures.some((s) => s.signerType === "gip") && (
                    <div className={styles.legalSection}>
                      <div className={styles.legalHeader}>ГИП</div>
                      {signatures
                        .filter((s) => s.signerType === "gip")
                        .map((s) => (
                          <div key={`gip-${s.employerId}`} className={styles.signatureRow}>
                            <span className={styles.signerName} title={s.employerName}>
                              {s.employerName}
                            </span>
                            <span
                              className={
                                s.signed ? styles.signedBadge : styles.notSignedBadge
                              }
                            >
                              {s.signed ? "Подпись" : "Нет"}
                            </span>
                          </div>
                        ))}
                    </div>
                  )}

                  {/* Юр.лицо */}
                  {signatures.some((s) => s.signerType === "legal") && (
                    <div className={styles.legalSection}>
                      <div className={styles.legalHeader}>Юр.лицо</div>
                      {signatures
                        .filter((s) => s.signerType === "legal")
                        .map((s) => (
                          <div key={`legal-${s.employerId}`} className={styles.signatureRow}>
                            <span className={styles.signerName} title={s.employerName}>
                              {s.employerName}
                            </span>
                            <span
                              className={
                                s.signed ? styles.signedBadge : styles.notSignedBadge
                              }
                            >
                              {s.signed ? "Подпись" : "Нет"}
                            </span>
                          </div>
                        ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )
        }
      </div >
    )
  }

  render() {
    const {
      isOpen,
      onClose,
      store, baseUrl
    } = this.props
    const { uploading, showUploadDialog, taskFiles, loading, selectedDeleteVersion, showDelete, showAssignDialog, selectedType, employersWorked, employersLegal, legal, implementer, selectedLegal, implementerSelectKey, showResetWarning } =
      this.state
    // Группируем файлы результата по имени

    const resultWorkers: SelectItem[] = [
      ...store.employee.employee
        .filter((emp) => !emp.fired)
        .map((e) => ({
          id: e.id,
          label: `(сотр) ${e.label}`,
          color: getEcpColor(e.signDateTo)
        })),
      ...store.outsourcers.outsourcers.map((e) => ({
        id: e.id,
        label: `(аутс) ${e.label}`,
        color: getEcpColor(e.signDateTo)
      }))
    ]

    const legalWorkers: SelectItem[] = [
      ...store.portfolios.portfolios.filter((portfolio) => portfolio.director)
        .map((e) => ({
          id: e.director!.id,
          label: `(сотр) ${e.director?.name}`,
          color: getEcpColor(store.employee.employee.find((emp) => emp.id === e.director?.id)?.signDateTo)
        })).filter((item, index, self) =>
          index === self.findIndex((t) => t.id === item.id)
        ),
      ...store.outsourcers.outsourcers.filter((o) => o.isLegalEntity).map((e) => ({
        id: e.id,
        label: `(аутс) ${e.label}`,
        color: getEcpColor(store.outsourcers.outsourcers.find((o) => o.id === e.id)?.signDateTo)
      }))
    ]
    return (
      <>
        {/* Диалог предупреждения об отсутствии или просрочке ЭЦП */}
        <Dialog
          title="Внимание! Проблемы с ЭЦП"
          isOpen={this.state.showNoEcpWarning}
          onClose={() => this.setState({ showNoEcpWarning: false })}
          backdropClassName="standard"
          className={`${styles.smallDialog} figma-dialog`}
        >
          <div className={`${Classes.DIALOG_BODY}`}>
            <div className={styles.warningContent}>

              {this.state.noEcpEmployees.length > 0 && (
                <>
                  <p className={styles.warningText}>
                    У следующих участников отсутствует отметка о наличии ЭЦП в карточке:
                  </p>
                  <div className={styles.noEcpList}>
                    {this.state.noEcpEmployees.map((emp, index) => (
                      <div key={`noecp-${index}`} className={styles.noEcpItem}>
                        • {emp.name} ({emp.type}) - {emp.personType}
                      </div>
                    ))}
                  </div>
                </>
              )}

              {this.state.expiredEcpEmployees.length > 0 && (
                <>
                  <p className={styles.warningText}>
                    У следующих участников истек срок действия ЭЦП:
                  </p>
                  <div className={styles.noEcpList}>
                    {this.state.expiredEcpEmployees.map((emp, index) => (
                      <div key={`expired-${index}`} className={styles.expiredEcpItem}>
                        • {emp.name} ({emp.type}) - {emp.personType}, истекла {emp.expiryDate}
                      </div>
                    ))}
                  </div>
                </>
              )}

              <p className={styles.warningText}>
                Продолжить сохранение?
              </p>
            </div>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <Buttons
              left={
                <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end", width: "100%" }}>
                  <PlanrButton
                    size="small"
                    type="greenish"
                    onClick={() => {
                      this.setState({ showNoEcpWarning: false })
                      this.performSaveDevelopers()
                    }}
                  >
                    Сохранить
                  </PlanrButton>
                  <PlanrButton
                    size="small"
                    type="graybtn"
                    onClick={() => this.setState({ showNoEcpWarning: false })}
                  >
                    Отмена
                  </PlanrButton>
                </div>
              }
            />
          </div>
        </Dialog>

        {/* Диалог подтверждения сброса подписей */}
        <Dialog
          title="Внимание!"
          isOpen={showResetWarning}
          onClose={() => this.setState({ showResetWarning: false })}
          backdropClassName="standard"
          className={`${styles.smallDialog} figma-dialog`}
        >
          <div className={`${Classes.DIALOG_BODY}`}>
            <div className={styles.warningContent}>
              <GeneralIcon
                type="general-warning"
                style={{
                  color: "#fbb360",
                  fontSize: "48px",
                  marginBottom: "16px",
                  display: "block",
                  margin: "0 auto 16px"
                }}
              />
              <p className={styles.warningText}>
                В списке отсутствует человек, который уже подписывал файл.
              </p>
              <p className={styles.warningText}>
                Все существующие подписи будут сброшены.
              </p>
              <p className={styles.warningText}>
                Вы действительно хотите продолжить?
              </p>
            </div>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <Buttons
              left={
                <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end", width: "100%" }}>
                  <PlanrButton
                    size="small"
                    type="danger"
                    onClick={this.confirmSaveDevelopers}
                  >
                    Продолжить
                  </PlanrButton>
                  <PlanrButton
                    size="small"
                    type="graybtn"
                    onClick={() => this.setState({ showResetWarning: false })}
                  >
                    Отмена
                  </PlanrButton>
                </div>
              }
            />
          </div>
        </Dialog>

        {/* Диалог подписей */}
        <Dialog
          title={`Виды работ (электронные подписи)`}
          isOpen={showAssignDialog}
          onClose={this.toggleAsignDialog}
          backdropClassName="standard"
          className={`${styles.ResultWorkersDialog} figma-dialog`}
        >
          <div className={`${Classes.DIALOG_BODY} `}>
            <div className={styles.mainWindow}>
              <div className={styles.column}>
                <div className={styles.columnRow} >
                  <div className={styles.label} style={{ fontSize: "12px" }}>
                    Сотрудник/Аутсорс
                  </div>
                  <div className={styles.label} style={{ fontSize: "12px" }}>
                    Вид работы
                  </div>
                  <div className={styles.icon}> </div>
                </div>
                {employersWorked.map((emplWorked, index) => (
                  <div className={styles.columnRow} key={index}>
                    <div className={styles.label}>
                      {emplWorked.name}
                    </div>
                    <div className={styles.label}>
                      {this.showType(emplWorked.type)}
                    </div>
                    <div className={styles.icon}>
                      <GeneralIcon
                        type="general-trash"
                        style={{
                          color: "#E31818",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          this.removeDeveloper(index, 'worked')
                        }}
                      />
                    </div>
                  </div>
                ))}

                <div className={styles.selectRow}>
                  <div className={styles.label}>
                    <SimpleSelect
                      key={implementerSelectKey}
                      className={`full-width-select ${Classes.FILL}`}
                      activeItem={implementer}
                      items={resultWorkers}
                      itemRenderer={renderSingleOption}
                      // disabled={selectedType.id === 'gip'}
                      onItemSelect={(i) => {
                        this.setState({ implementer: i })
                      }}
                      popoverProps={{
                        boundary: "viewport",
                        popoverClassName: "import-spendings-table__select",
                      }}
                      inputProps={{
                        placeholder: "Участник",
                      }}
                      filterable={true}
                      itemPredicate={filterItemPredicate}
                    >
                      <DefaultSelectedOption option={implementer} style={{ overflow: "hidden", maxWidth: "340px" }} />
                    </SimpleSelect>
                  </div>
                  <div className={styles.label}>
                    <SimpleSelect
                      className={`full-width-select ${Classes.FILL}`}
                      activeItem={selectedType}
                      items={signatureTypeList}
                      itemRenderer={renderSingleOption}
                      onItemSelect={(i) => {
                        this.setState({ selectedType: i })
                      }}
                      popoverProps={{
                        boundary: "viewport",
                        popoverClassName: "import-spendings-table__select",
                      }}
                      inputProps={{
                        placeholder: "Вид работы",
                      }}
                      filterable={false}
                    >
                      <DefaultSelectedOption option={selectedType} style={{ overflow: "hidden", maxWidth: "200px" }} />
                    </SimpleSelect>
                  </div>
                  <div className={styles.icon}>
                    <PlanrButton
                      type="secondary"
                      size="small"
                      onClick={() => this.addNewDeveloper()}
                      style={{ marginLeft: "-120px" }}
                    >
                      Добавить
                    </PlanrButton>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.window}>
              <div className={styles.columnWindow} style={{ width: "30%" }}>
                <div className={styles.dialogLabel}>Юр. лицо (необязательно)</div>
                <GeneralIcon
                  size={20}
                  type={legal ? "general-checkbox" : "general-zero-checkbox"}
                  style={{
                    color: "#1dd278",
                    cursor: "pointer",
                    marginLeft: "10px",
                    marginTop: "15px"
                  }}
                  onClick={() => {
                    this.setState({ legal: !this.state.legal })
                  }}
                />
              </div>
            </div>
            {legal && (
              <div className={styles.window}>
                <div className={styles.column} style={{ width: "100%" }}>

                  {employersLegal.map((emplWorked, index) => (
                    <div className={styles.columnRow} key={index}>
                      <div className={styles.label}>
                        {emplWorked.name}
                      </div>
                      <div className={styles.icon}>
                        <GeneralIcon
                          type="general-trash"
                          style={{
                            color: "#E31818",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            this.removeDeveloper(index, 'legal')
                          }}
                        />
                      </div>
                    </div>
                  ))}
                  <div className={styles.selectRow}>
                    <div className={styles.label}> <SimpleSelect
                      // key={implementerSelectKey}
                      className={`full-width-select ${Classes.FILL}`}
                      activeItem={selectedLegal}
                      items={legalWorkers}
                      itemRenderer={renderSingleOption}
                      // disabled={selectedType.id === 'gip'}
                      onItemSelect={(i) => {
                        this.setState({ selectedLegal: i })
                      }}
                      popoverProps={{
                        boundary: "viewport",
                        popoverClassName: "import-spendings-table__select",
                      }}
                      inputProps={{
                        placeholder: "Участник",
                      }}
                      filterable={true}
                      itemPredicate={filterItemPredicate}
                    >
                      <DefaultSelectedOption option={selectedLegal} style={{ overflow: "hidden", width: "340px" }} />
                    </SimpleSelect></div>

                    <div className={styles.icon}>
                      <PlanrButton
                        type="secondary"
                        size="small"
                        onClick={() => this.addNewLegal()}
                        style={{ marginRight: "40px" }}
                      >
                        Добавить
                      </PlanrButton>
                    </div>
                  </div>

                </div>
              </div>
            )}
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <Buttons
              left={
                <div style={{ display: "flex" }}>
                  <PlanrButton size="small" type="greenish" onClick={this.saveDevelopers}>
                    Сохранить
                  </PlanrButton>
                  <PlanrButton size="small" type="graybtn" onClick={this.toggleAsignDialog}>
                    Отмена
                  </PlanrButton>
                </div>
              }
            />
          </div>
        </Dialog>



        <Dialog
          title={`Удаление версии`}
          isOpen={showDelete}
          onClose={() => this.setState({ showDelete: false, selectedDeleteVersion: null })}
          backdropClassName="standard"
          className={`${styles.FilesDialog} figma-dialog`}
        >
          <div className={`${Classes.DIALOG_BODY} `}>
            <div className={styles.showDialogTask}>
              {selectedDeleteVersion && `Вы действительно хотите удалить файл "${selectedDeleteVersion.fileName}" (версия ${selectedDeleteVersion.version})?`}
            </div>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <Buttons
              left={
                <div style={{ display: "flex" }}>
                  <PlanrButton
                    size="small"
                    type="danger"
                    onClick={() => {
                      if (selectedDeleteVersion) {
                        store.removeVersion(selectedDeleteVersion.fileId, selectedDeleteVersion.version)
                        this.setState({ showDelete: false, selectedDeleteVersion: null })
                      }
                    }}
                  >
                    Удалить
                  </PlanrButton>
                  <PlanrButton
                    size="small"
                    type="graybtn"
                    onClick={() => this.setState({ showDelete: false, selectedDeleteVersion: null })}
                  >
                    Отмена
                  </PlanrButton>
                </div>
              }
            />
          </div>
        </Dialog>
        <Dialog
          title={`Мои файлы для подписи`}
          isOpen={isOpen}
          onClose={onClose}
          backdropClassName="standard"
          className={`${styles.mainDialog} figma-dialog`}
        >
          <div className={`${Classes.DIALOG_BODY}`}>
            {loading ? (
              <div className={styles.loaderContainer}>
                <Spinner />
              </div>
            ) : (
              <div className={styles.contentContainer}>
                <div className={styles.toolbar}>
                  <PlanrButton
                    type="lightblueish"
                    icon="general-plus"
                    onClick={this.openUploadDialog}
                    disabled={uploading}
                  >
                    Добавить файл
                  </PlanrButton>
                </div>

                <div className={styles.filesList}>
                  {store.files.length === 0 ? (
                    <div className={styles.emptyState}>
                      <GeneralIcon
                        type="general-file"
                        style={{ fontSize: "48px", color: "#ccc", marginBottom: "16px" }}
                      />
                      <p>Нет загруженных файлов</p>
                      <p className={styles.emptyStateHint}>
                        Нажмите "Добавить файл", чтобы загрузить файл результата
                      </p>
                    </div>
                  ) : (

                    <>
                      {/* Шапка таблицы */}
                      <div className={styles.filesTableHeader}>
                        <div className={styles.fileNameCol}>Файл</div>
                        <div className={styles.fileVersionCol}>Версия</div>
                        <div className={styles.fileDateCol}>Дата загрузки</div>
                        <div className={styles.fileActionsCol}>Действия</div>
                      </div>
                      {/* Список файлов (только последние версии) */}

                      <div className={styles.filesTableItems}> {Object.entries(
                        store.files.reduce((acc, file) => {
                          if (!acc[file.fileName]) {
                            acc[file.fileName] = []
                          }
                          acc[file.fileName].push(file)
                          return acc
                        }, {} as Record<string, EmployeeSignatureFileType[]>)
                      ).map(([fileName, fileVersions]) => {
                        const sortedVersions = [...fileVersions].sort((a, b) => b.version - a.version)
                        const latestVersion = sortedVersions[0]
                        return this.renderFileRow(latestVersion, sortedVersions)
                      })}</div>

                    </>)}
                </div>
              </div>
            )}
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <Buttons
              left={
                <PlanrButton size="small" type="graybtn" onClick={onClose}>
                  Закрыть
                </PlanrButton>
              }
            />
          </div>
        </Dialog>

        {/* Диалог загрузки файла */}
        <Dialog
          title="Загрузка файлов"
          isOpen={showUploadDialog}
          onClose={this.closeUploadDialog}
          backdropClassName="standard"
          className={`${styles.uploadDialog} figma-dialog`}
        >
          <div className={`${Classes.DIALOG_BODY}`}>
            <div className={styles.instructionBox}>
              <GeneralIcon type="general-info" style={{ marginRight: "8px", flexShrink: 0 }} />
              <span>
                Вы можете загрузить несколько файлов. Если файл с таким именем уже существует,
                его версия автоматически увеличится.
              </span>
            </div>
            {taskFiles.map((file, index) => {
              const resultFiles = store.files
                || []

              const existingFiles = resultFiles.filter((f) => f.fileName === file.name)

              const isNewVersion = existingFiles.length > 0
              const nextVersion = isNewVersion
                ? Math.max(...existingFiles.map((f) => f.version)) + 1
                : 1

              return (
                <div key={index} className={styles.fileItemWithBadge}>
                  <FileLink<any>
                    key={index}
                    baseUrl={baseUrl}
                    file={{ fileId: file.id, fileName: file.name }}
                    style={{
                      height: "50px",
                      width: "100%",
                      border: "3px dashed #edf0f2",
                      marginBottom: "15px",
                      maxWidth: "700px"

                    }}
                    readOnly={false}
                    onRemove={() => {
                      this.removeTaskFilesFromState(file.id)
                    }}
                  />
                  <span className={isNewVersion ? styles.versionBadge : styles.newFileBadge}>
                    {isNewVersion ? `Новая версия ${nextVersion}` : "Новый файл"}
                  </span>
                </div>
              )
            })}
            <div className={styles.uploadArea}>
              <PlanRDndUploader
                accept={"*"}
                multiple={false}
                withLoader={true}
                style={{
                  border: "3px dashed #edf0f2",
                  height: "80px",
                  width: "100%",
                  maxWidth: "700px"
                }}
                onFileSelected={this.taskFilesUpload}
              />
            </div>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <Buttons
              left={
                <div style={{ display: "flex" }}>
                  <PlanrButton
                    size="small"
                    type="greenish"
                    onClick={this.saveUploadedFiles}
                    style={{ minWidth: "120px" }}
                    disabled={uploading}
                  >
                    {uploading && <Spinner intent="primary" size={16} />}
                    {!uploading && "Сохранить"}
                  </PlanrButton>
                  <PlanrButton size="small" type="graybtn" onClick={this.closeUploadDialog}>
                    Отмена
                  </PlanrButton>
                </div>
              }
            />
          </div>
        </Dialog>

        {/* Диалог выбора подписантов */}
        {/* <SignatureAssignDialog
          isOpen={showAssignDialog}
          onClose={this.closeAssignDialog}
          fileName={selectedFileForAssign?.name || ""}
          onSave={this.handleSaveSignatures}
          employee={employee}
          agents={agents}
          portfolios={portfolios}
          orderEmployerId={orderEmployerId}
        /> */}
      </>
    )
  }
}

export const OwnSignaturesFilesList = observer(SignaturesListBase)


const VersionDetails = ({
  fileVersions,
  baseUrl,
  downloadVersion,
  removeVersion,
}: {
  fileVersions: EmployeeSignatureFileType[]
  baseUrl: string
  downloadVersion: (fileId: string, version: number) => Promise<boolean>
  removeVersion: (fileId: string, version: number) => void
}) => {
  const [showDelete, setShowDelete] = React.useState(false)
  const [selectedVersion, setSelectedVersion] = React.useState<EmployeeSignatureFileType | null>(null)

  const handleDeleteClick = (version: EmployeeSignatureFileType) => {
    setSelectedVersion(version)
    setShowDelete(true)
  }

  return (
    <div className={styles.popupVersions}>
      <Dialog
        title="Удаление версии"
        isOpen={showDelete}
        onClose={() => setShowDelete(false)}
        backdropClassName="standard"
        className={`${styles.FilesDialog} figma-dialog`}
      >
        <div className={`${Classes.DIALOG_BODY}`}>
          <div className={styles.showDialogTask}>
            {selectedVersion &&
              `Вы действительно хотите удалить файл "${selectedVersion.fileName}" (версия ${selectedVersion.version})?`
            }
          </div>
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <Buttons
            left={
              <div style={{ display: "flex" }}>
                <PlanrButton
                  size="small"
                  type="danger"
                  onClick={() => {
                    if (selectedVersion) {
                      removeVersion(selectedVersion.fileId, selectedVersion.version)
                      setShowDelete(false)
                    }
                  }}
                >
                  Удалить
                </PlanrButton>
                <PlanrButton
                  size="small"
                  type="graybtn"
                  onClick={() => setShowDelete(false)}
                >
                  Отмена
                </PlanrButton>
              </div>
            }
          />
        </div>
      </Dialog>

      <div className={styles.versionDetailsContainer}>
        <div className={styles.filesTableHeader}>
          <div className={styles.fileNameCol}>Файл</div>
          <div className={styles.fileVersionCol}>Версия</div>
          <div className={styles.fileDateCol}>Дата загрузки</div>
          <div className={styles.fileActionsCol}></div>
        </div>

        {fileVersions.map((file) => (
          <div key={file.id} className={styles.fileVersionGroup}>
            <div className={styles.fileRow}>
              <div className={styles.fileNameCol}>
                <FileLink
                  baseUrl={baseUrl}
                  file={{
                    fileId: file.id,
                    fileName: file.fileName,
                  }}
                  readOnly={true}
                  onRemove={() => { }}
                  style={{
                    whiteSpace: "normal",
                    fontSize: "10px",
                    height: "auto",
                    padding: "8px 12px",
                    borderColor: "#ea561e",
                    color: "#ea561e"
                  }}
                />
              </div>
              <div className={styles.fileVersionCol}>
                <span className={styles.versionLink}>
                  Версия_{file.version}
                </span>
              </div>
              <div className={styles.fileDateCol}>
                {file.date}
                <br />
                <span className={styles.time}>{file.time || ''}</span>
              </div>
              <div className={styles.fileActionsCol} style={{ display: 'flex', gap: '8px' }}>
                <PlanrButton
                  type="lightgreenish"
                  size="small"
                  icon="general-download"
                  onClick={() => downloadVersion(file.fileId, file.version)}
                  title="Скачать файл"
                />
                <PlanrButton
                  type="lightdanger"
                  size="small"
                  icon="general-trash"
                  title="Удалить версию"
                  onClick={() => handleDeleteClick(file)}
                />
              </div>
            </div>
            {/* Отображение подписей */}
            {file.noRoles.length > 0 && <div className={styles.signaturesNoRoles}>Подписей без роли: {file.noRoles.length}</div>}
            {file.employers.length > 0 && (
              <div className={styles.signaturesContainer}>
                <div className={styles.signaturesThreeColumns}>
                  {/* Столбец "Разработал" */}
                  <div className={styles.signatureColumn}>
                    <div className={styles.columnHeader}>Разработал</div>
                    {file.employers
                      .filter((s) => s.signerType === "worked")
                      .map((s) => (
                        <div key={`worked-${s.employerId}`} className={styles.signatureRow}>
                          <span className={styles.signerName} title={s.employerName}>
                            {s.employerName}
                          </span>
                          <span
                            className={
                              s.signed ? styles.signedBadge : styles.notSignedBadge
                            }
                          >
                            {s.signed ? "Подпись" : "Нет"}
                          </span>
                        </div>
                      ))}
                    {file.employers.filter((s) => s.signerType === "worked").length === 0 && (
                      <div className={styles.emptyColumn}>—</div>
                    )}
                  </div>

                  {/* Столбец "Проверил" | "рук отдела"*/}
                  <div className={styles.signatureColumn}>
                    <div className={styles.columnHeader}>Проверил</div>
                    {file.employers
                      .filter((s) => s.signerType === "checked")
                      .map((s) => (
                        <div key={`checked-${s.employerId}`} className={styles.signatureRow}>
                          <span className={styles.signerName} title={s.employerName}>
                            {s.employerName}
                          </span>
                          <span
                            className={
                              s.signed ? styles.signedBadge : styles.notSignedBadge
                            }
                          >
                            {s.signed ? "Подпись" : "Нет"}
                          </span>
                        </div>
                      ))}
                    {file.employers.filter((s) => s.signerType === "checked").length === 0 && (
                      <div className={styles.emptyColumn}>—</div>
                    )}

                    {/* Рук отдела */}
                    {file.employers.some((s) => s.signerType === "leader") && (
                      <div className={styles.legalSection}>
                        <div className={styles.legalHeader}>Начальник отдела</div>
                        {file.employers
                          .filter((s) => s.signerType === "leader")
                          .map((s) => (
                            <div key={`leader-${s.employerId}`} className={styles.signatureRow}>
                              <span className={styles.signerName} title={s.employerName}>
                                {s.employerName}
                              </span>
                              <span
                                className={
                                  s.signed ? styles.signedBadge : styles.notSignedBadge
                                }
                              >
                                {s.signed ? "Подпись" : "Нет"}
                              </span>
                            </div>
                          ))}
                      </div>
                    )}
                  </div>

                  {/* Столбец "Нормоконтроль" + Юр.лицо + ГИП */}
                  <div className={styles.signatureColumn}>
                    <div className={styles.columnHeader}>Нормоконтроль</div>
                    {file.employers
                      .filter((s) => s.signerType === "control")
                      .map((s) => (
                        <div key={`control-${s.employerId}`} className={styles.signatureRow}>
                          <span className={styles.signerName} title={s.employerName}>
                            {s.employerName}
                          </span>
                          <span
                            className={
                              s.signed ? styles.signedBadge : styles.notSignedBadge
                            }
                          >
                            {s.signed ? "Подпись" : "Нет"}
                          </span>
                        </div>
                      ))}
                    {file.employers.filter((s) => s.signerType === "control").length === 0 && (
                      <div className={styles.emptyColumn}>—</div>
                    )}

                    {/* ГИП */}
                    {file.employers.some((s) => s.signerType === "gip") && (
                      <div className={styles.legalSection}>
                        <div className={styles.legalHeader}>ГИП</div>
                        {file.employers
                          .filter((s) => s.signerType === "gip")
                          .map((s) => (
                            <div key={`gip-${s.employerId}`} className={styles.signatureRow}>
                              <span className={styles.signerName} title={s.employerName}>
                                {s.employerName}
                              </span>
                              <span
                                className={
                                  s.signed ? styles.signedBadge : styles.notSignedBadge
                                }
                              >
                                {s.signed ? "Подпись" : "Нет"}
                              </span>
                            </div>
                          ))}
                      </div>
                    )}

                    {/* Юр.лицо */}
                    {file.employers.some((s) => s.signerType === "legal") && (
                      <div className={styles.legalSection}>
                        <div className={styles.legalHeader}>Юр.лицо</div>
                        {file.employers
                          .filter((s) => s.signerType === "legal")
                          .map((s) => (
                            <div key={`legal-${s.employerId}`} className={styles.signatureRow}>
                              <span className={styles.signerName} title={s.employerName}>
                                {s.employerName}
                              </span>
                              <span
                                className={
                                  s.signed ? styles.signedBadge : styles.notSignedBadge
                                }
                              >
                                {s.signed ? "Подпись" : "Нет"}
                              </span>
                            </div>
                          ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

const DownloadButton = (props: { loading: boolean; onClick: () => void; gray?: boolean, title?: string, round?: boolean }) => {
  return (
    <PlanrButton
      type={props.gray ? "graybtn" : "lightgreenish"}
      size={!props.gray && !props.round ? "small" : "medium"}
      icon={props.loading ? undefined : "general-download"}
      onClick={props.onClick}
      disabled={props.loading}
      round={props.gray || props.round ? true : false}
      title={props.title || "Скачать архив с файлом и ЭЦП"}
    >
      {props.loading && <Spinner intent="primary" size={16} />}
    </PlanrButton>
  )
}